import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI, fmtError } from '@/lib/api';
import Logo from '@/components/Logo';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await authAPI.forgot({ email });
      setSent(true);
    } catch (err) { setError(fmtError(err)); }
  };

  return (
    <div className="min-h-screen bg-black relative overflow-hidden">
      <div className="max-w-md mx-auto px-6 py-14 relative">
        <Link to="/" className="inline-block mb-10"><Logo size={28} /></Link>
        <div className="card-tech rounded-lg p-8">
          <div className="label-sm mb-2">Password reset</div>
          <h1 className="font-display text-3xl">Forgot your password?</h1>
          <p className="text-sm text-zinc-500 mt-1">Enter your email and we'll send you a reset link.</p>

          {sent ? (
            <div className="mt-6 text-sm text-[#00ff66]" data-testid="forgot-success">
              If an account exists for {email}, a reset link has been sent.
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-3" data-testid="forgot-form">
              <input className="input-tech" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@email.com" data-testid="forgot-email" />
              {error && <div className="text-sm text-[#ff3366]" data-testid="forgot-error">{error}</div>}
              <button className="btn-primary w-full justify-center" data-testid="forgot-submit">Send reset link</button>
            </form>
          )}
          <p className="text-xs text-zinc-500 mt-5 text-center">
            Back to <Link to="/login" className="text-white hover:text-[#00ff66]">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
